import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import Body from "./components/Body";
import Creator from "./components/Creator";
import Brand from "./components/Brand";
import LoginPage from "./pages/Auth/LoginPage";
import SignupPage from "./pages/Auth/SignupPage";
import RoleSelectionPage from "./pages/Onboarding/RoleSelectionPage";
import BrandOnBoardingPage from "./components/BrandOnBoardingPage"; // Placeholder
import CreatorOnBoarding from "./components/CreatorOnBoarding"; // Placeholder
import WaitlistPage from "./pages/Onboarding/WaitlistPage";
import ComingSoonPage from "./components/ComingSoonPage";
import InstagramCallback from "./pages/Auth/InstagramCallback";
import BrandDashboard from "./pages/Dashboard/BrandDashboard";
import BrandMessages from "./pages/Brand/BrandMessages";
import BrandSettings from "./pages/Brand/BrandSettings";
import BrandCampaigns from "./pages/Brand/BrandCampaigns";
import CreateCampaign from "./pages/Brand/CreateCampaign";
import CampaignDetails from "./pages/Brand/CampaignDetails";
import CreatorDashboard from "./pages/Dashboard/CreatorDashboard";
import CreatorCampaigns from "./pages/Creator/CreatorCampaigns";
import FindCreators from "./pages/Brand/FindCreators/FindCreators";
import CreatorProfile from "./pages/Brand/FindCreators/CreatorProfile";
import CreatorBrands from "./pages/Creator/CreatorBrands";
import BrandProfile from "./pages/Creator/BrandProfile";
import CreatorCampaignDetail from "./pages/Creator/CreatorCampaignDetail";
import CreatorMessages from "./pages/Creator/CreatorMessages";
import CreatorSettings from "./pages/Creator/CreatorSettings";
import CreatorPublicProfile from "./pages/Creator/CreatorPublicProfile";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import TermsOfUse from "./pages/Legal/TermsOfUse";
import CSAEPolicy from "./pages/Legal/CSAEPolicy";

function App() {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <Body />,
    },
    {
      path: "/brand/create-campaign",
      element: <CreateCampaign />,
    },
    {
      path: "/brand/campaigns/:id",
      element: <CampaignDetails />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/signup",
      element: <SignupPage />,
    },
    {
      path: "/onboarding",
      element: <RoleSelectionPage />,
    },
    {
      path: "/Creator",
      element: <Creator />,
    },
    {
      path: "/Brand",
      element: <Brand />,
    },
    {
      path: "/onboarding/brand",
      element: <WaitlistPage role="brand" />,
    },
    {
      path: "/onboarding/creator",
      element: <WaitlistPage role="creator" />,
    },
    // Keep old paths for backward compatibility if needed, or remove them
    {
      path: "/BrandOnBoardingPage",
      element: <BrandOnBoardingPage />,
    },
    {
      path: "/CreatorOnBoardingPage",
      element: <CreatorOnBoarding />,
    },
    {
      path: "/ComingSoonPage",
      element: <ComingSoonPage />,
    },
    {
      path: "/brand/dashboard",
      element: <BrandDashboard />,
    },
    {
      path: "/brand/campaigns",
      element: <BrandCampaigns />,
    },
    {
      path: "/brand/search",
      element: <FindCreators />,
    },
    {
      path: "/brand/messages",
      element: <BrandMessages />,
    },
    {
      path: "/brand/creators/:id",
      element: <CreatorProfile />,
    },
    {
      path: "/brand/settings",
      element: <BrandSettings />,
    },

    {
      path: "/creator/dashboard",
      element: <CreatorDashboard />,
    },
    {
      path: "/creator/find-work", // Updated to "find-work" to match sidebar
      element: <CreatorCampaigns />,
    },
    {
      path: "/creator/brands",
      element: <CreatorBrands />,
    },
    {
      path: "/creator/brands/:id",
      element: <BrandProfile />,
    },
    {
      path: "/creator/campaigns/:campaignId",
      element: <CreatorCampaignDetail />,
    },
    {
      path: "/creator/messages",
      element: <CreatorMessages />,
    },
    {
      path: "/creator/profile", // Also servers as Settings
      element: <CreatorSettings />,
    },
    {
      path: "/auth/instagram/callback",
      element: <InstagramCallback />,
    },
    {
      path: "/creator/public-profile",
      element: <CreatorPublicProfile />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/terms-of-use",
      element: <TermsOfUse />,
    },
    {
      path: "/csae-policy",
      element: <CSAEPolicy />,
    },
  ]);

  return (
    <div style={{ backgroundColor: "#fffaf5", minHeight: "100vh" }}>
      <RouterProvider router={appRouter} />
    </div>
  );
}

export default App;
